import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCalendarWarning(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 176 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_31_6017)">
        <circle cx="88.5" cy="60" r="50" stroke="url(#paint0_linear_31_6017)" strokeWidth="20" />
        <path
          d="M81.4167 49.1663V45.833M95.5833 49.1663V45.833M81.4167 55.833H95.5833M79.75 74.9997H97.25C100.011 74.9997 102.25 72.7611 102.25 69.9997V54.1663C102.25 51.4049 100.011 49.1663 97.25 49.1663H79.75C76.9886 49.1663 74.75 51.4049 74.75 54.1663V69.9997C74.75 72.7611 76.9886 74.9997 79.75 74.9997Z"
          stroke="#0C1C43"
          strokeLinecap="round"
        />
      </g>
      <path
        d="M48.5 10.5C59.2696 10.5 68 19.2304 68 30C68 40.7696 59.2696 49.5 48.5 49.5C37.7304 49.5 29 40.7696 29 30C29 19.2304 37.7304 10.5 48.5 10.5Z"
        fill="#BD6801"
      />
      <path
        d="M48.5 10.5C59.2696 10.5 68 19.2304 68 30C68 40.7696 59.2696 49.5 48.5 49.5C37.7304 49.5 29 40.7696 29 30C29 19.2304 37.7304 10.5 48.5 10.5Z"
        stroke="white"
      />
      <path
        d="M48.5 24V31M48.5 34V35"
        stroke="white"
        strokeWidth="1.51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_31_6017"
          x1="88.5"
          y1="10"
          x2="88.5"
          y2="110"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor="#FFE3C3" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="clip0_31_6017">
          <rect x="38.5" y="10" width="100" height="100" rx="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCalendarWarning);
export default ForwardRef;
